import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import NotificationBeaconsTable from './NotificationBeaconsTable'
import { useTableFetch, pageToSortPairs } from 'commons/reactTableFetch'
import effects from 'app/effects/effects'
import LargeToolbar from 'app/components/LargeToolbar'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import SearchBar from 'app/components/searchBar/SearchBar'
import BeaconOverview from './overview/BeaconOverview'
import { usePlace } from 'commons/usePlace'
import EmptyStateView from 'app/components/EmptyStateView'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'
import { isNil, path, not } from 'ramda'
import { openDialog } from 'app/auth/store/actions/createNotification.actions'
import { ACTION_EDIT, ACTION_NEW, BEACON_DIALOG } from 'app/constants/compose'
import { useDispatch } from 'react-redux'
import { SCOPE_BEACON } from 'app/constants/scope'
import { matchPath } from 'react-router'
import { Routes } from 'app/services/routeService/routeService'
import { SECONDARY } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { useOpenCompose } from 'app/main/composeMessage/useOpenCompose'

const fetchData = (page) => {
  return effects.apis.notificationsList({
    page: page.currentPage,
    limit: page.pageSize,
    sort: pageToSortPairs(page),
    keyword: page.keyword,
    type: 1,
    scope: SCOPE_BEACON,
  })
}

const NotificationBeacons = ({ history }) => {
  const { formatMessage } = useIntl()
  const place = usePlace()
  const [isOnline] = useIsOnline()
  const dispatch = useDispatch()
  const {
    pageInfo,
    onFetchData,
    refetchData,
    startFetchData,
    endFetchData,
    showErrorDialogue,
    search,
    showPagination,
    defaultPageSize,
  } = useTableFetch(fetchData)

  const onNotificationCreate = () => {
    startFetchData()
    refetchData().finally(endFetchData)
  }

  const onSuccseAndRedirectPage = (res, scope) => {
    const pathname =
      scope === SCOPE_BEACON
        ? Routes.beaconNotification()
        : Routes.notificationTimeline()

    const match = matchPath(history.location.pathname, {
      path: pathname,
    })

    if (isNil(match)) {
      history.push(pathname)
    } else {
      onNotificationCreate()
    }
  }

  const { onOpenCompose } = useOpenCompose()

  const openComposeMessageDialog = () => {
    dispatch(
      openDialog({
        initialValues: undefined,
        onCreateSuccess: onSuccseAndRedirectPage,
        type: BEACON_DIALOG,
        action: ACTION_NEW,
      }),
    )
  }

  const onClickOpenComposeDialog = (id) => {
    onOpenCompose(id, BEACON_DIALOG, onSuccseAndRedirectPage, ACTION_EDIT)
  }

  const isBeaconEnabled = path(['info', 'isBeaconEnabled'], place)
  const shouldShowEmptyView = () => {
    return pageInfo.isFirsttimeFetchingNoData
  }

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => refetchData()} />
  }

  if (not(isBeaconEnabled)) {
    return <BeaconOverview />
  }
  return (
    <>
      <ContentToolbarPage
        isFitViewPort
        contentToolbar={
          <LargeToolbar
            content={
              <>
                <Typography variant="h6">
                  <FormattedMessage id="navigation.beacons.beaconNotifications.label" />
                </Typography>
              </>
            }
            right={
              <>
                <SearchBar
                  className="ltr:mr-8 rtl:ml-8"
                  searchFor={formatMessage({
                    id: 'navigation.beacons.beaconNotifications.label',
                  })}
                  {...search}
                />
                <ContainedButton
                  color={SECONDARY}
                  data-testid="create-beacon-message"
                  onClick={openComposeMessageDialog}
                >
                  <div className="flex w-full h-full">
                    <span className="ml-3">
                      {formatMessage({
                        id: 'beaconNotification.add.action',
                      })}
                    </span>
                  </div>
                </ContainedButton>
              </>
            }
          />
        }
        content={
          <>
            {shouldShowEmptyView() ? (
              <EmptyStateView
                title={formatMessage({
                  id: 'beaconNotification.table.notHave.notification',
                })}
              >
                <ContainedButton
                  color={SECONDARY}
                  onClick={openComposeMessageDialog}
                >
                  <div className="flex w-full h-full">
                    <span className="ml-3">
                      {formatMessage({
                        id: 'beaconNotification.add.action',
                      })}
                    </span>
                  </div>
                </ContainedButton>
              </EmptyStateView>
            ) : (
              <NotificationBeaconsTable
                pageInfo={pageInfo}
                onFetchData={onFetchData}
                refetchData={refetchData}
                startFetchData={startFetchData}
                endFetchData={endFetchData}
                showErrorDialogue={showErrorDialogue}
                onClickRow={onClickOpenComposeDialog}
                showPagination={showPagination}
                defaultPageSize={defaultPageSize}
              />
            )}
          </>
        }
      />
    </>
  )
}

export default NotificationBeacons
